import React from "react";
import { BaseButton } from "./BaseButton";

export function DangerButton(props) {
	return (
		<BaseButton {...props} color="red">
			{props.children}
		</BaseButton>
	);
}
